import { PropertyFilters, PropertyFiltersProps } from "../components/PropertyFilters";

export type PropertyFiltersSidebarProps = PropertyFiltersProps;

export const PropertyFiltersSidebar = (PropertyFiltersProps: PropertyFiltersProps) => {
  return <div className="w-full mt-5">
    <PropertyFilters {...PropertyFiltersProps} />
  </div>
};